import {useDrugList} from './hooks';
import Headline from 'components/atoms/typography/headline/headline.component';
import {
  TypographyFontStyles,
  TypographySizes,
} from 'components/atoms/typography/base-text/constants';
import Paragraph from 'components/atoms/typography/paragraph/paragraph.component';
import LIGHT_COLORS from 'theme/colors/light-colors';
import Clickable from 'components/atoms/button/clickable/clickable.component';

const DrugList = () => {
  const {drugList, navigateToDrugDetails} = useDrugList();

  return (
    <div
      style={{
        justifyContent: 'center',
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'column',
      }}>
      <Headline
        size={TypographySizes['3XL']}
        fontStyle={TypographyFontStyles.Bold}
        stringProps={{plainText: '~~ Item List ~~'}}
      />

      {drugList?.map((drugItem, _) => (
        <Clickable
          key={drugItem.uid}
          onClick={() => {
            console.log('clicked');
            navigateToDrugDetails(drugItem);
          }}
          style={{
            flexDirection: 'column',
            display: 'flex',
            flex: 1,
            justifyContent: 'center',
            alignItems: 'center',
            margin: 15,
          }}>
          <Headline
            size={TypographySizes['2XL']}
            stringProps={{plainText: drugItem.name}}
          />
          <Paragraph
            size={TypographySizes.S}
            textStyle={{color: LIGHT_COLORS.textTertiaryWhite}}
            fontStyle={TypographyFontStyles.Semibold}
            stringProps={{plainText: `${drugItem.stock}`}}
          />
        </Clickable>
      ))}
    </div>
  );
};

export default DrugList;
